import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommitteeMemberSearchDto } from '../../shared/dto/committee-member-search.dto';
import { SecurityElementNames } from 'src/app/shared/auth/constants/security-element-names.service';

@Component({
  selector: 'wl-committee-members',
  templateUrl: './committee-members.component.html',
  styleUrls: ['./committee-members.component.less'],
    standalone: false
})
export class CommitteeMembersComponent implements OnInit, OnChanges {
  @Input() committeeId: number;

  searchParams = new CommitteeMemberSearchDto();
  constructor(public securityElementNames: SecurityElementNames) {}

  ngOnInit(): void {}

  ngOnChanges(simpleChanges: SimpleChanges) {
    if (simpleChanges.committeeId && this.committeeId) {
      this.searchParams.CommitteeIds = [this.committeeId];
    }
  }
}
